import React, {createContext, useContext, useEffect, useState} from 'react';
import {ChatContextType, ChatDraft} from "../types/interfaces/chats";
import {serializeFile} from "../helpers/media";
import {User} from "../types/users";

const ChatContext = createContext<ChatContextType | undefined>(undefined);

export const useChatContext = () => {
    const context = useContext(ChatContext);
    if (!context) {
        throw new Error('Использование useChatContext должно быть внутри связанного с ним провайдера ChatProvider');
    }
    return context;
};

export const ChatProvider: React.FC<{
    children: React.ReactNode
}> = ({children}) => {
    const [chatUsers, setChatUsers] = useState<User[]>([]);
    const updateChatUsers = (users: User[]) => {
        setChatUsers(users)
    }

    // Черновики
    const [drafts, setDrafts] = useState<Record<string, ChatDraft>>(() => {
        // Загрузка черновиков
        const savedDrafts = localStorage.getItem('xChatDrafts');
        return savedDrafts ? JSON.parse(savedDrafts) : {};
    });

    useEffect(() => {
        // Сохранение черновика в localStorage при изменениях
        localStorage.setItem('xChatDrafts', JSON.stringify(drafts));
    }, [drafts]);

    const updateDraft = (chatId: string, text?: string, isImportant?: boolean, attachments: File[] = []) => {
        const serializers = attachments.map(file => serializeFile(file))
        Promise.all(serializers).then(serializedAttachments => {
            setDrafts((prevDrafts) => ({
                ...prevDrafts,
                [chatId]: {text, isImportant, attachments: serializedAttachments},
            }));
        }).catch(e => {
            console.error(e)
        });
    };

    const updateDraftFiles = (chatId: string, attachments: File[] = []) => {
        const serializers = attachments.map(file => serializeFile(file))
        Promise.all(serializers).then(serializedAttachments => {
            setDrafts((prevDrafts) => ({
                ...prevDrafts,
                [chatId]: {...prevDrafts[chatId], attachments: serializedAttachments},
            }));
        }).catch(e => {
            console.error(e)
        });
    };

    const updateDraftText = (chatId: string, text?: string, isImportant?: boolean) => {
        setDrafts((prevDrafts) => ({
            ...prevDrafts,
            [chatId]: {...prevDrafts[chatId], text, isImportant},
        }));
    };

    const clearDraft = (chatId: string) => {
        setDrafts((prevDrafts) => {
            const newDrafts = {...prevDrafts};
            delete newDrafts[chatId];
            return newDrafts;
        });
    };

    return (
        <ChatContext.Provider
            value={{chatUsers, updateChatUsers, drafts, updateDraft, updateDraftFiles, updateDraftText, clearDraft}}>
            {children}
        </ChatContext.Provider>
    );
};